import { Configuration } from './conf/app.constants';
import { Injectable } from '@angular/core';

import { Location } from '@angular/common';
import { ServiceLocator } from './ServiceLocator';

import { Color } from 'chart.js';

import { PlycaDataService } from '../services/plyca.service';
import { DossierDTO, I18nData } from './api/plyca-dtos';

import {
  MessageDTOModal,
  messageComponent,
} from './components/message.component';
import { HelpService } from './components/common/help/help.service';
import { TranslateService } from '@ngx-translate/core';
import { showcontentComponent } from './components/showcontent.component';
import { Router } from '@angular/router';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng-lts/dynamicdialog';
import {
  ConfirmationService,
  MessageService,
  Confirmation,
} from 'primeng-lts/api';
import { BaseDirectiveObject } from './components/common/base-directive-object';
import { WaitLoadingService } from './components/common/waitLoading/wait-loading.service';
import { HelpElementDTO } from './components/common/help/help.dtos';
import { Store } from '@ngrx/store';
import { UserPrefs } from './api/UserPrefs-dto';
import { AppState } from './store/AppState';
import { finalize, switchMap, take, tap } from 'rxjs/operators';
import { SET_USERPREFS } from './store/userPrefs';
import { UserPrefsService } from './store/user-prefs.service';

@Injectable()
export class UIService extends BaseDirectiveObject {
  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/

  public USERS_COLOR_LIST = [
    '#2f4b5d',
    '#00bfff',
    '#72b9ec',
    '#1768b5',
    '#17b566',
    '#1a7e55',
    '#20b2aa',
    '#25a071',
    '#ae2328',
    '#4feab9',
    '#4fc7ea',
    '#522424',
    '#633939',
    '#b48425',
    '#68c4af',
    '#7e1a43',
    '#80e56f',
    '#8b9dc3',
    '#a560d6',
    '#b56617',
    '#b8860b',
    '#ba55d3',
    '#c0afaf',
    '#c0c0c0',
    '#c71585',
    '#cd5c5c',
    '#cec2e5',
    '#dc143c',
    '#dcedc1',
    '#f08080',
    '#ff4040',
    '#ffa500',
    '#faebd7',
  ];

  /* ['rgba(81,87,74,0.5)', 'rgba(228,191,128,0.5)', 'rgba(225,101,82,0.5)', 'rgba(101,56,125,0.5)', 'rgba(226,121,163,0.5)',
  'rgba(124,159,176,0.5)', 'rgba(86,152,196,0.5)', 'rgba(154,191,136,0.5)',
  'rgba(68,124,105,0.5)', 'rgba(233,215,142,0.5)', 'rgba(201,74,83,0.5)', 'rgba(78,36,114,0.5)' , 'rgba(224,89,139,0.5)',
  'rgba(116,196,147,0.5)',  'rgba(226,151,93,0.5)', 'rgba(190,81,104,0.5)', 'rgba(145,99,182,0.5)',
  'rgba(142,140,109,0.5)',  'rgba(241,150,112,0.5)', 'rgba(163,73,116,0.5)' ,  'rgba(153,55,103,0.5)'];*/

  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/
  //  public static readonly CHARTS_COLOR_LIST= ['#20a391', '#7aa450', '#fccb8b', '#65645f', '#e2975d', '#e16552', '#be5168', '#a34974', '#993767', '#65387d', '#4e2472', '#9163b6', '#e279a3', '#e0598b', '#7c9fb0', '#5698c4', '#9abf88', '#51574a', '#447c69', '#74c493', '#8e8c6d', '#e4bf80', '#e9d78e', '#f19670', '#c94a53'];
  // backgroundColor:        ['rgba(68,124,105,0.5)', 'rgba(233,215,142,0.5)', 'rgba(226,151,93,0.5)', 'rgba(201,74,83,0.5)', 'rgba(163,73,116,0.5)', 'rgba(153,55,103,0.5)', 'rgba(101,56,125,0.5)', 'rgba(78,36,114,0.5)', 'rgba(145,99,182,0.5)', 'rgba(226,121,163,0.5)', 'rgba(224,89,139,0.5)', 'rgba(124,159,176,0.5)', 'rgba(86,152,196,0.5)', 'rgba(154,191,136,0.5)', 'rgba(81,87,74,0.5)', 'rgba(116,196,147,0.5)' , 'rgba(142,140,109,0.5)', 'rgba(228,191,128,0.5)', 'rgba(241,150,112,0.5)', 'rgba(225,101,82,0.5)', 'rgba(190,81,104,0.5)'],
  // hoverBackgroundColor:   ['rgb(68,124,105)', 'rgb(233,215,142)', 'rgb(226,151,93)', 'rgb(201,74,83)', 'rgb(163,73,116)', 'rgb(153,55,103)', 'rgb(101,56,125)', 'rgb(78,36,114)', 'rgb(145,99,182)' , 'rgb(226,121,163)', 'rgb(224,89,139)', 'rgb(124,159,176)', 'rgb(86,152,196)', 'rgb(154,191,136)', 'rgb(81,87,74)', 'rgb(116,196,147)', 'rgb(142,140,109)', 'rgb(228,191,128)', 'rgb(241,150,112)' , 'rgb(225,101,82)', 'rgb(190,81,104)'],
  // borderColor:            ['rgb(68,124,105)', 'rgb(233,215,142)' , 'rgb(225,101,82)', 'rgb(201,74,83)', 'rgb(163,73,116)', 'rgb(153,55,103)', 'rgb(101,56,125)', 'rgb(78,36,114)', 'rgb(145,99,182)' , 'rgb(226,121,163)', 'rgb(224,89,139)', 'rgb(124,159,176)', 'rgb(86,152,196)', 'rgb(154,191,136)', 'rgb(81,87,74)', 'rgb(116,196,147)', 'rgb(142,140,109)', 'rgb(228,191,128)', 'rgb(226,151,93)', 'rgb(241,150,112)', 'rgb(190,81,104)'],
  /* CHARTS */

  public chartColorsDef: Color = <Color>{};

  public backgroundColor = [
    'rgba(37, 119, 181,1)',
    'rgba(86,152,196,0.5)',
    'rgba(124, 180, 124,1)',

    'rgba(66,165,245,0.5)',
    'rgba(156,204,101,0.5)',

    'rgba(228,191,128,0.5)',
    'rgba(225,101,82,0.5)',
    'rgba(101,56,125,0.5)',
    'rgba(226,121,163,0.5)',
    'rgba(124,159,176,0.5)',
    'rgba(122, 146, 163,1)',
    'rgba(154,191,136,0.5)',
    'rgba(68,124,105,0.5)',
    'rgba(233,215,142,0.5)',
    'rgba(153,55,103,0.5)',
    'rgba(201,74,83,0.5)',
    'rgba(78,36,114,0.5)',
    'rgba(224,89,139,0.5)',
    'rgba(116,196,147,0.5)',
    'rgba(226,151,93,0.5)',
    'rgba(190,81,104,0.5)',
    'rgba(145,99,182,0.5)',
    'rgba(142,140,109,0.5)',
    'rgba(241,150,112,0.5)',
    'rgba(163,73,116,0.5)',
    'rgba(81,87,74,0.5)',
  ];
  public hoverBackgroundColor = [
    'rgba(11, 98, 164,1)',
    'rgb(86,152,196)',
    'rgba(124, 180, 124,1)',

    'rgba(66,165,245,1)',
    'rgba(156,204,101,1)',

    'rgb(228,191,128)',
    'rgb(225,101,82)',
    'rgb(101,56,125)',
    'rgb(226,121,163)',
    'rgb(124,159,176)',
    'rgba(136, 136, 136,1)',
    'rgb(154,191,136)',
    'rgb(68,124,105)',
    'rgb(233,215,142)',
    'rgb(153,55,103)',
    'rgb(201,74,83)',
    'rgb(78,36,114)',
    'rgb(224,89,139)',
    'rgb(116,196,147)',
    'rgb(226,151,93)',
    'rgb(190,81,104)',
    'rgb(145,99,182)',
    'rgb(142,140,109)',
    'rgb(241,150,112)',
    'rgb(163,73,116)',
    'rgb(81,87,74)',
  ];
  public borderColor = [
    'rgba(11, 98, 164,1)',
    'rgb(86,152,196)',
    'rgba(77, 167, 77,1)',

    'rgba(30,136,229,1)',
    'rgba(124,179,66,1)',

    'rgb(228,191,128)',
    'rgb(225,101,82)',
    'rgb(101,56,125)',
    'rgb(226,121,163)',
    'rgb(124,159,176)',
    'rgba(136, 136, 136,1)',
    'rgb(154,191,136)',
    'rgb(68,124,105)',
    'rgb(233,215,142)',
    'rgb(153,55,103)',
    'rgb(201,74,83)',
    'rgb(78,36,114)',
    'rgb(224,89,139)',
    'rgb(116,196,147)',
    'rgb(226,151,93)',
    'rgb(190,81,104)',
    'rgb(145,99,182)',
    'rgb(142,140,109)',
    'rgb(241,150,112)',
    'rgb(163,73,116)',
    'rgb(81,87,74)',
  ];

  //  borderWidth: 2,
  //  pointBackgroundColor: 'rgba(255,255,255,1)',
  //  pointHoverBackgroundColor: 'rgba(255,255,255,1)',
  //  pointBorderColor: 'rgba(122, 146, 163,0.8)',
  //  pointHoverBorderColor: 'rgba(122, 146, 163,1)'
  /*    ,fill: false this option hide background-color */
  // };

  public lineChartColorsDef: Color = <Color>{};
  // backgroundColor: ['rgba(37, 119, 181,1)'],
  // hoverBackgroundColor: ['rgba(11, 98, 164,1)'],
  // borderColor: ['rgba(11, 98, 164,1)'],

  // borderWidth: 2,
  // pointBackgroundColor: 'rgba(255,255,255,1)',
  // pointHoverBackgroundColor: 'rgba(255,255,255,1)',
  // pointBorderColor: 'rgba(122, 146, 163,0.8)',
  // pointHoverBorderColor: 'rgba(122, 146, 163,1)',
  /*    ,fill: false this option hide background-color */
  // };
  public CHART_COLORS: Array<Color> = [
    this.chartColorsDef,
    this.chartColorsDef,
    this.chartColorsDef,
    this.chartColorsDef,
    this.chartColorsDef,
    this.chartColorsDef,
  ];

  // public LINE_CHART_COLORS: Array<Color> = [
  //   this.lineChartColorsDef,
  //   this.lineChartColorsDef,
  //   this.lineChartColorsDef,
  //   this.lineChartColorsDef,
  //   this.lineChartColorsDef,
  //   this.lineChartColorsDef,
  // ];
  pChartOptions: any = {
    responsive: true,
    maintainAspectRatio: true,
    segmentShowStroke: true,
    fill: true,
    tension: 0.4,
    backgroundColor: this.backgroundColor,
    borderColor: this.borderColor,
    hoverBackgroundColor: this.backgroundColor,
    borderWidth: 2,
    plugins: {
      title: {
        display: false,
        text: 'Texto a mostrar si true',
      },
      legend: {
        display: false,
        position: 'right',
        fullWidth: false,
        show: true,
        location: 'sw',
        rendererOptions: {
          numberRows: 1,
        },
      },
    },
  };
  barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: true,
    segmentShowStroke: true,
    fill: true,
    tension: 0.4,
    backgroundColor: this.backgroundColor,
    borderColor: this.borderColor,
    borderWidth: 2,
    plugins: {
      title: {
        display: false,
        text: 'Texto a mostrar si true',
      },
      legend: {
        display: false,
        position: 'right',
        fullWidth: false,
        show: true,
        location: 'sw',
        rendererOptions: {
          numberRows: 1,
        },
      },
    },
  };
  barChartLegend: any = {
    legend: {
      display: true,
      labels: {
        fontColor: 'rgb(255, 99, 132)',
      },
    },
  };

  context: MessageDTOModal;

  // msgs: Message[] = [];
  private dialogService: DialogService;
  userPrefs: UserPrefs;

  constructor(
    public plycaService: PlycaDataService,
    private confirmationService: ConfirmationService,
    private location: Location,
    protected router: Router,
    public translateService: TranslateService,
    private messageService: MessageService,
    private waitService: WaitLoadingService,
    private configuration: Configuration,
    private store: Store<AppState>,
    private userPrefsService: UserPrefsService
  ) {
    super();
    this.dialogService = ServiceLocator.injector.get(DialogService);
  }

  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/
  /**********************************************************************************************/

  // getCHART_COLORS(chartType: string) {
  //   if (chartType === 'line') {
  //     return this.LINE_CHART_COLORS;
  //   } else {
  //     return this.CHART_COLORS;
  //   }
  // }

  showSuccess(
    message: string | I18nData,
    title: string | I18nData,
    level?: string
  ) {
    level = level || 'info';
    let msgTxt = '';
    let titleTxt = '';

    if (message instanceof I18nData) {
      this.subscribe(
        this.translateService.get(message.messageKey, message.messageParams),
        (translation: string) => (msgTxt = translation)
      );
    } else {
      msgTxt = message;
    }

    if (title instanceof I18nData) {
      this.subscribe(
        this.translateService.get(title.messageKey, title.messageParams),
        (translation: string) => (titleTxt = translation)
      );
    } else {
      titleTxt = title;
    }

    let icon = 'pi-check';
    switch (level) {
      case 'info':
        icon = 'pi-info-circle';
        break;
      case 'warn':
        icon = 'pi-exclamation-triangle';
        break;
      case 'error':
        icon = 'pi-times-circle';
        break;
      case 'success':
        icon = 'pi-check';
        break;
      default:
        icon = 'pi-kk';
    }
    let msg = { severity: level, summary: titleTxt, detail: msgTxt, life: 5000, icon: icon };
    this.messageService.add(msg);
  }

  // para que funcione:
  // 1. comp es el componente modal a abrir.
  // 2. comp debe estar en los entrycomponents del modulo del componente que invoque
  openDossier(comp: any, dossier?: DossierDTO, dossierId?: string): void {
    let config: DynamicDialogConfig = {
      showHeader: false,
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '90vh' },
    };

    config['dossier'] = dossier;
    config['dossierId'] = dossierId;
    this.dialogService.open(comp, config);
  }

  /**
   * Opens a modal window inside an existing component.
   * @param content The content to display, either string, template ref or a component.
   * @param config Additional settings.
   * @returns {DialogRef}
   */
  showMessage(
    message: string | I18nData,
    titleKey?: string | I18nData,
    styleClass?: string,
    buttonKey?: string
  ): DynamicDialogRef {
    this.waitService.cancelWaiting();
    let context = new MessageDTOModal(message, titleKey);
    // messageData: string | I18nData, titleKey?: string | I18nData) {
    // let config: any = ServiceLocator.injector.get(DynamicDialogConfig);
    let config: DynamicDialogConfig = {
      header: context.title,
      width: '50%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: styleClass,
      baseZIndex: 3000,
      data: {
        buttonKey: buttonKey,
      },
    };
    config['context'] = context;

    const ref = this.dialogService.open(messageComponent, config);
    return ref;
  }
  showContent(
    message: string | I18nData,
    titleKey?: string | I18nData,
    styleClass?: string,
    printEnabled?: boolean
  ): DynamicDialogRef {
    let context = new MessageDTOModal(message, titleKey);
    // messageData: string | I18nData, titleKey?: string | I18nData) {
    // let config: any = ServiceLocator.injector.get(DynamicDialogConfig);
    let config: DynamicDialogConfig = {
      header: context.title,
      width: '90%',
      style: { overflow: 'scroll' },
      styleClass: styleClass,

      baseZIndex: 3000,
    };
    config['context'] = context;
    printEnabled = printEnabled ? printEnabled : false;
    config['printEnabled'] = printEnabled;

    const ref = this.dialogService.open(showcontentComponent, config);
    return ref;
  }
  showConfirmMessage(_config: Confirmation): ConfirmationService {
    return this.confirmationService.confirm(_config);
  }

  routeBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['mainView']);
    }
  }

  public showGeneralErrorMessage(): void {
    this.showMessage(
      this.translateService.instant('General.errorMessage'),
      this.translateService.instant('General.error'),
      'errorStyle'
    );
  }

  showENSAlertMessage(test = false) {
    if (test) {
      this.subscribe(
        this.userPrefsService.getUserPrefs().pipe(
          take(1),
          tap((prefs: UserPrefs) => {
            // inicializar la variable por si no viene en las preferencias
            if (prefs.mainViewPrefs?.ENSAlertViewed === false) {
              this.openENSAlertMessage();
              prefs.mainViewPrefs.ENSAlertViewed = true;
              this.store.dispatch(SET_USERPREFS({ userPrefs: prefs }));
            }
          })
        )
      );
    } else {
      this.openENSAlertMessage();
    }
  }

  // Metodo para comparar cadenas sin tener en cuenta mayúsculas/minúsculas ni acentos
  public normalizeAndCompareStrings(origen: string, destino: string) {
    let origen_normalized = this.normalizeString(origen);
    let destino_normalized = this.normalizeString(destino);
    return (
      origen_normalized
        .toLowerCase()
        .indexOf(destino_normalized.toLowerCase()) !== -1
    );
  }

  // Metodo para normalizar cadenas sin tener en cuenta mayúsculas/minúsculas ni acentos
  public normalizeString(origen: string) {
    let origen_normalized = origen
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, ''); // Old method: .replace(/[\u0300-\u036f]/g, "");
    return origen_normalized;
  }

  openENSAlertMessage() {
    this.subscribe(
      this.plycaService.get<HelpElementDTO>(
        this.configuration.HELP_ELEMENT_SERVICE_URL,
        'ENS001'
      ),
      (help: HelpElementDTO) => {
        if (help) {
          this.waitService.startWaiting();
          this.plycaService
            .get<HelpElementDTO>(
              this.configuration.HELP_ELEMENT_SERVICE_URL,
              'ENS001'
            )
            .pipe(
              take(1), // deshacer suscripcion tras primera invocacion
              finalize(() => this.waitService.cancelWaiting())
            )
            .subscribe((help: HelpElementDTO) => {
              if (help) {
                let helpContent =
                  '<div class="ql-snow"><div class="ql-editor">' +
                  help.content +
                  '</div></div>';
                this.showContent(helpContent, help.shortDesc);
              } else {
                console.log(
                  'NO ENCONTRADA ELEMENTO DE AYUDA CON ID: ' + 'ENS001'
                );
              }
            });
        } else {
          console.log('NO ENCONTRADA ELEMENTO DE AYUDA CON ID: ' + 'ENS001');
        }
      }
    );
  }

  public cancelEvent(event: Event) {
    event.stopPropagation();
    event.returnValue = false;
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }
    return false;
  }
}

export class DossierDTOModal {
  protected helpService: HelpService;
  tags: string[];
  constructor(public dossier: DossierDTO) {
    this.helpService = ServiceLocator.injector.get(HelpService);
    this.helpService
      .getStoreTagsObservable()
      .pipe(switchMap((helpTags) => (this.tags = helpTags)))
      .subscribe();
  }
}

export function generateRandomIdentifier(length?: number) {
  if (!length) {
    length = 32;
  }
  return Math.round(
    Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)
  )
    .toString(36)
    .slice(1);
}
